import AppRoutes from "./routes/AppRoutes";
import NetworkStatusBanner from "./components/NetworkStatusBanner";
import "./styles/lms.css";

function App() {
  return (
    <>
      <AppRoutes />
      <NetworkStatusBanner />
    </>
  );
}

export default App;
